import { useState, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { fetchSocket, fetchChatData } from "./FetchData";
import Chat from "../pages/Chat";
import { fetchWalletInfoBank, fetchWalletInfoCrypto } from "../pages/FetchTransactions";
import { checkWalletsType } from "../utils/configData";
import LoadingElement from "../components/features/LoadingElement";


const ChatRoute = () => {
  const [flag, setFlag] = useState(false);
  const { chat_id } = useParams(); // Destructure chat_id from the URL parameters
  const [chatData, setChatData] = useState(null);
  const [sellWallet, setSellWallet] = useState(null);
  const [buyWallet, setBuyWallet] = useState(null);
  const [redirectTo, setRedirectTo] = useState(null);
  const [chatToken, setChatToken] = useState(null);

  useEffect(() => {
    if (chat_id) {
      fetchSocket(chat_id).then((data) => {
        if (data) {
          setChatToken(data);
          fetchChatData(chat_id).then((data) => {
            if (false) {
              // data === "user_not_permited"
              setRedirectTo("/"); // Redirect to transactions-list if user is not permitted
            } else {
              const check = checkWalletsType(data.buy_currency) === "bank";
              fetchWalletInfoBank(check ? data.buy_wallet : data.sell_wallet).then((data) => {
                if (check) {
                  setBuyWallet(data);
                } else {
                  setSellWallet(data);
                }
              });
              fetchWalletInfoCrypto(!check ? data.buy_wallet : data.sell_wallet).then((data) => {
                if (!check) {
                  setBuyWallet(data);
                } else {
                  setSellWallet(data);
                }
              });

              setChatData({
                ...data,
                details: [
                  {
                    crypto: data.details[0].crypto,
                  },
                  {
                    bank: data.details[1].bank,
                  },
                ],
              });
              setFlag(true);
            }
          });
        } else {
          setFlag(false);
        }
      });
    }
  }, [chat_id]); // Dependency array to re-run this effect when chat_id changes

  return redirectTo ? (
    <Navigate to={redirectTo} />
  ) : flag && sellWallet && buyWallet && chatData ? (
    <Chat chatID={chat_id} chatData={chatData} sellWalletData={sellWallet} buyWalletData={buyWallet} chatToken={chatToken}/>
  ) : (
    <LoadingElement mini={false} />
  );
};

export default ChatRoute;
